import {Component,Input, OnInit} from '@angular/core';
import {ListOpeCarte} from '@domain/opecarte/list-opecarte';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {Router} from "@angular/router";

@Component({
    selector: 'opecarte-list-item',
    host: {'data-test-id': 'opecarte-list-item'},
    templateUrl: './opecarte-list-item.component.html'
})
export class OpeCarteListItemComponent extends ListViewItem<ListOpeCarte> implements OnInit {
    /** Liste des opérations carte */
    @Input() data: ListOpeCarte;
    
    /** Liste des notes de frais associées parsées */
    ndfAssociesParsed: Array<{id: string, libelle: string}> = [];

    /**
     * Constructeur
     */
    constructor(private router: Router) {
        super();
    }
    
    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Parsing des notes de frais associées lors de l'initialisation
        if (this.data && this.data.ndfAssocies) {
            this.parseNdfAssocies();
        }
    }

    /**
     * Ouvre la note de frais correspondante
     * @param idNdf Identifiant de la note de frais
     */
    openNdf(idNdf: string): void {
        //Conversion de l'ID en nombre
        const idNdfNumber = parseInt(idNdf, 10);

        //Navigation vers la note de frais
        this.router.navigate(['NDF', idNdfNumber]);
    }

    /**
     * Parse la chaîne ndfAssocies pour extraire les ID et libellés
     */
    private parseNdfAssocies(): void {
        //Pour chaque élément, on extrait l'ID et le libellé
        this.ndfAssociesParsed = this.data.ndfAssocies
            ? this.data.ndfAssocies
                .split(', ')
                .map(item => item.split(':'))
                .map(([id, libelle]) => ({ id, libelle }))
            : [];
    }
}
